import { Col, Container, Row } from "reactstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Galery = () => {

  const listGalery = [
    { name:"Canada, British Columbia invest in infrastructure at Northern Lights College", img:"assets/images/gallery/gallery1.webp" },
    { name:"Northern post-secondary institutions collaborating on international educational pathways", img:"assets/images/gallery/gallery2.webp" },
    { name:"Students return from study abroad at Kansai Gaidai University in Japan", img:"assets/images/gallery/gallery3.webp" },
    { name:"New Program: Access to Practical Nursing", img:"assets/images/gallery/gallery4.webp" },
    { name:"Northern Lights College signs Indigenous Education Protocols at this year’s Reawakening Our Language Gathering", img:"assets/images/gallery/gallery5.webp" },
    { name:"worldskills-regional-competition-2024-painting-and-decorating-phoenix-boon-silver-michael-stella-bronze-annabelle-barrow-gold", img:"assets/images/gallery/gallery6.webp" },
  ]

  return (
    <section className="section" id="galery">
      <Container>
        <Row className="">
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              selector=".masonry-item"
              download={false}
            >
              <div className="masonry">
                {listGalery.map((item, id) => (
                  <a 
                    key={id} 
                    href={item.img}
                    className="masonry-item"
                  >
                    <img 
                      alt={item.name} 
                      src={item.img} 
                      className="img-fluid" 
                    />
                  </a>  
                ))}      
              </div>            
            </LightGallery>   
        </Row>
      </Container>
    </section>
  );
};

export default Galery;